import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id B4B2B3EB-A8C5-48C3-8F82-4F295424B396
 * name align-horizontal-distribute
 * version: 6.5.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/align-horizontal-distribute.svg
 * tags
 * - Text / Content / Format 
 */
export const AlignHorizontalDistributeIcon = createSvgIcon(<><path d="M4 22H2V2H4V22M22 2H20V22H22V2M13.5 7H10.5V17H13.5V7Z" /></>, 'AlignHorizontalDistributeIcon');
export default AlignHorizontalDistributeIcon